import "./style/Coaches.css";

import { useCallback, useEffect, useState } from "react";
import {
  getMissingEmailPlayers,
  updatePlayer,
  updatePlayerEmail,
} from "../apicalls/players";
import { isAuthenticated } from "../apicalls/auth";

function MissingEmailPlayers() {
  const [players, setPlayers] = useState([]);
  const [emailInputs, setEmailInputs] = useState({});
  const [genderInputs, setGenderInputs] = useState({});
  const [message, setMessage] = useState("");
  const [loadingId, setLoadingId] = useState("");

  const user = isAuthenticated();
  const accessToken = user?.access_token;

  const loadPlayers = useCallback(() => {
    if (!accessToken) {
      return;
    }

    getMissingEmailPlayers(accessToken).then((data) => {
      const list = Array.isArray(data) ? data : [];
      setPlayers(list);
      setEmailInputs(
        list.reduce((acc, player) => {
          acc[player.user_id] = "";
          return acc;
        }, {})
      );
      setGenderInputs(
        list.reduce((acc, player) => {
          acc[player.user_id] = player.rating_gender || "";
          return acc;
        }, {})
      );
    });
  }, [accessToken]);

  useEffect(() => {
    loadPlayers();
  }, [loadPlayers]);

  const saveEmail = (player) => {
    const email = (emailInputs[player.user_id] || "").trim();
    if (!email) {
      setMessage("Email is required");
      return;
    }

    setLoadingId(`email-${player.user_id}`);
    setMessage("");
    updatePlayerEmail(player.user_id, email, accessToken).then((data) => {
      setLoadingId("");
      if (data?.detail || data?.details) {
        setMessage(data.detail || "Unable to update email");
        return;
      }
      setMessage("Email updated");
      loadPlayers();
    });
  };

  const saveGender = (player) => {
    setLoadingId(`gender-${player.user_id}`);
    setMessage("");
    updatePlayer(
      player.user_id,
      { rating_gender: genderInputs[player.user_id] || null },
      accessToken
    ).then((data) => {
      setLoadingId("");
      if (!data?.[0]?.id) {
        setMessage("Unable to update gender");
        return;
      }
      setMessage("Gender updated");
      loadPlayers();
    });
  };

  return (
    <main>
      <div className="coaches_title">
        <h1>Missing Email Players</h1>
      </div>
      {message ? <div className="my-2">{message}</div> : ""}
      <div className="col-11">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Phone</th>
                <th scope="col">Current Email</th>
                <th scope="col">New Email</th>
                <th scope="col">Gender</th>
                <th scope="col">Save</th>
              </tr>
            </thead>
            <tbody>
              {players.length > 0 ? (
                players.map((player) => (
                  <tr key={player.user_id}>
                    <td className="fw-bold">{player.full_name}</td>
                    <td>{player.phone || "-"}</td>
                    <td>{player.email || "-"}</td>
                    <td>
                      <input
                        type="email"
                        value={emailInputs[player.user_id] || ""}
                        onChange={(event) =>
                          setEmailInputs({
                            ...emailInputs,
                            [player.user_id]: event.target.value,
                          })
                        }
                        placeholder="player@example.com"
                      />
                    </td>
                    <td>
                      <select
                        value={genderInputs[player.user_id] || ""}
                        onChange={(event) =>
                          setGenderInputs({
                            ...genderInputs,
                            [player.user_id]: event.target.value,
                          })
                        }
                      >
                        <option value="">Unknown</option>
                        <option value="M">Male</option>
                        <option value="F">Female</option>
                      </select>
                    </td>
                    <td>
                      <button
                        className="coaches_button"
                        disabled={loadingId === `email-${player.user_id}`}
                        onClick={() => saveEmail(player)}
                      >
                        Email
                      </button>
                      <button
                        className="coaches_button mx-2"
                        disabled={loadingId === `gender-${player.user_id}`}
                        onClick={() => saveGender(player)}
                      >
                        Gender
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">
                    <h2>No players with missing email</h2>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </main>
  );
}

export default MissingEmailPlayers;
